import { ChangeDetectorRef, Component, DestroyRef, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { DashboardControlArgs } from 'devexpress-dashboard';
import { DxDashboardControlComponent } from 'devexpress-dashboard-angular';
import { TextBoxItemEditorExtension } from 'devexpress-dashboard/designer/text-box-item-editor-extension';
import { interval, Observable, Subscription } from 'rxjs';
import { ExcelExportService } from 'src/app/common/excel-export-service';
import { FunnelD3ItemExtension } from 'src/app/extensions/funnel-d3-item';
import { GanttItemExtension } from 'src/app/extensions/gantt-item';
import { TreeViewItemExtension } from 'src/app/extensions/hierarchical-tree-view-item';
import { OnlineMapItemExtension } from 'src/app/extensions/online-map-item';
import { ParameterItemExtension } from 'src/app/extensions/parameter-item';
import { PolarChartItemExtension } from 'src/app/extensions/polar-chart-item';
import { SimpleTableItemExtension } from 'src/app/extensions/simple-table-item';
import { WebPageItemExtension } from 'src/app/extensions/webpage-item';
import DataGrid from 'devextreme/ui/data_grid';
import { DxDataGridItemExtension } from 'src/app/extensions/data-grid-custom';
import { InputPopupComponent } from '../dashboard/input-popup.component';
import { DashboardBIService } from '../dashboard/bi-dashboard.service';
import { ChartAxisMaxValueExtension } from 'src/app/extensions/chart-axis-max-value-extension';
import { ChartConstantLinesExtension } from 'src/app/extensions/chart-constant-lines-extension';
import { ChartLineOptionsExtension } from 'src/app/extensions/chart-line-options-extension';
import { ChartScaleBreaksExtension } from 'src/app/extensions/chart-scale-breaks-extension';
import { DashboardDescriptionExtension } from 'src/app/extensions/dashboard-description-extension';
import { GridHeaderFilterExtension } from 'src/app/extensions/grid-header-filter-extension';
import { ItemDescriptionExtension } from 'src/app/extensions/item-description-extension';
import { ItemIdentifierExtension } from 'src/app/extensions/Identifier-extension';
import { AuthService } from 'src/app/services/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BaseService } from 'src/app/services/base.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-bi-dashboard',
  templateUrl: './bi-dashboard.component.html',
  styleUrls: ['./bi-dashboard.component.scss']
  //,encapsulation: ViewEncapsulation.None // Use Shadow DOM encapsulation
  ,
  standalone: false
})
export class BiDashboardComponent {

  DevExpressApiUrl = "";
  apiHeader: {};

  @Input() workingMode = 'Viewer';
  @Input() dashboardId = '';
  @Input() enableClearCache = false;
  @Input() refreshCache = false;


  private extension: DxDataGridItemExtension | null = null;
  @ViewChild("dashboardCrt", { static: false }) dxdashboardComponent: DxDashboardControlComponent;


  @ViewChild('inputPopup') inputPopup: InputPopupComponent;
  private eventsDashboardSubscription: Subscription;

  @Input() eventsDashboard: Observable<string>;

  private timerTokenSubscription: Subscription;

  constructor(private baseService: BaseService, private readonly excelExportService: ExcelExportService,
    private readonly cdr: ChangeDetectorRef,
    private readonly dashboardServie: DashboardBIService,
    private readonly authService: AuthService,
    private readonly _destroyRef: DestroyRef, private localStorageService: LocalStorageService
  ) {

    if (this.baseService.getNewOptions() != null && this.baseService.getNewOptions().headers != null) {
      this.apiHeader = this.baseService.getNewOptions().headers;
      this.DevExpressApiUrl = this.baseService.getCorrectUrl("dashboard");
    }
  }

  ngOnInit() {
    this.eventsDashboardSubscription = this.eventsDashboard
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((action: string) => {
        this.dashboardEventWithAction(action);
      });
    this.DataGridDefaultOptionsOverwrite();
  }



  ngOnChanges(changes: SimpleChanges) {
    if ((changes.dashboardId && !changes.dashboardId.isFirstChange()) ||
      (changes.refreshCache && !changes.refreshCache.isFirstChange())) {
      //this.loadDashboard();
      setTimeout(async () => {
        await this.loadDashboard();
      }, 1000); // 1000ms = 1 second
    }
  }

  // Replace loadDashboard() with:
  onDashboardInitialized() {
    //console.log('Dashboard initialized');
    this.isLoading = false;
    this.loadError = false;

    // Load any saved state
    // const value = sessionStorage.getItem('SaveBookmarkDashboard123');
    // if (value && this.dxdashboardComponent?.instance) {
    //   this.dxdashboardComponent.instance.setDashboardState(value);
    // }

    //  let dashboardControl = this.dxdashboardComponent.instance;
    // // Helper function to check and register extensions only if they are not already registered
    // const registerIfNotExists = (extensionInstance: any, extensionName: string) => {
    //   if (!dashboardControl.findExtension(extensionName)) {
    //     //console.log(`Registering extension: ${extensionName}`);
    //     dashboardControl.registerExtension(extensionInstance);
    //   } else {
    //     console.log(`Extension already registered: ${extensionName}`);
    //   }
    // };

    // // Handle dashboard content changes if needed
    // if (this.dashboardId) {
    //   // Ensure the dashboard control is initialized

    //     // Remove existing extension if it exists
    //     const existingExt = dashboardControl.findExtension('CustomDataGridExtension');
    //     if (existingExt) {
    //       dashboardControl.unregisterExtension('CustomDataGridExtension');
    //     }

    //     // Register the custom data grid extension with the current dashboardId
    //     registerIfNotExists(
    //       new DxDataGridItemExtension(dashboardControl, this.dashboardId, this.dashboardServie),
    //       'CustomDataGridExtension'
    //     );

    //}
  }

  onError(e: any) {
    console.error('Dashboard error:', e);
    // this.isLoading = false;
    // this.loadError = true;
    // this.cdr.detectChanges();
  }
  // Add these properties to your component
  isLoading = false;
  loadError = false;
  showDebugInfo = false; // Set to true for debugging
  async retryLoad() {
    this.loadError = false;
    await this.loadDashboard();
  }

  private previousDashboardId: string;
  async loadDashboard() {
    if (!this.dashboardId || !this.dxdashboardComponent?.instance) {
      return;
    }

    if (this.dashboardId === this.previousDashboardId) return;

    this.isLoading = true;
    this.loadError = false;
    // Clear existing dashboard

    this.dxdashboardComponent.instance.unloadDashboard();

    // Load new dashboard
    try {
      await this.dxdashboardComponent.instance.loadDashboard(this.dashboardId);

      this.initializeExtension(); // Reapply logic after load
      this.previousDashboardId = this.dashboardId;
    } catch (error) {
      console.error('Dashboard load failed:', error);
      this.loadError = true;
    } finally {
      this.isLoading = false;
      this.cdr.detectChanges();
    }
  }
  // async loadDashboard() {
  //   const value = sessionStorage.getItem('SaveBookmarkDashboard123');
  //   if (value) {
  //     this.dxdashboardComponent.instance.setDashboardState(value);
  //   }
  // }


  async ngAfterViewInit() {
    // Initial load after view is ready
    await this.loadDashboard();
  }


  parameterDialogExtensionWidth = 500;
  parameterDialogExtensionHeight = 500;

  onBeforeRender(args: DashboardControlArgs) {
    let dashboardControl = args.component;
    if (this.apiHeader != null) {
      dashboardControl.option('ajaxRemoteService', {
        headers: this.apiHeader,
        withCredentials: true
      });
    }

    // Helper function to check and register extensions only if they are not already registered
    const registerIfNotExists = (extensionInstance: any, extensionName: string) => {
      if (!dashboardControl.findExtension(extensionName)) {
        dashboardControl.registerExtension(extensionInstance);
      } else {
        console.log(`Extension already registered: ${extensionName}`);
      }
    };




    // Correct extension names that `DashboardControl` assigns internally
    registerIfNotExists(new TextBoxItemEditorExtension(dashboardControl), 'textBoxItemEditor');
    registerIfNotExists(new SimpleTableItemExtension(dashboardControl), 'CustomItemSimpleTable');
    registerIfNotExists(new FunnelD3ItemExtension(dashboardControl), 'FunnelD3');
    registerIfNotExists(new PolarChartItemExtension(dashboardControl), 'PolarChart');
    registerIfNotExists(new ParameterItemExtension(dashboardControl), 'ParameterItem');
    registerIfNotExists(new OnlineMapItemExtension(dashboardControl), 'OnlineMap');
    registerIfNotExists(new WebPageItemExtension(dashboardControl), 'WebPage');
    registerIfNotExists(new GanttItemExtension(dashboardControl), 'GanttItem');
    registerIfNotExists(new TreeViewItemExtension(dashboardControl), 'TreeView');

    //this editor is not used in the dashboard control, but it is used in the designer control name : DashboardPanelExtension
    //registerIfNotExists(new DashboardPanelExtension(dashboardControl), 'DashboardPanelExtension');

    registerIfNotExists(new ItemIdentifierExtension(dashboardControl), 'ItemIdentifierExtension');
    registerIfNotExists(new ItemDescriptionExtension(dashboardControl), 'ItemDescription');
    registerIfNotExists(new ChartLineOptionsExtension(dashboardControl), 'ChartLineOptions');
    registerIfNotExists(new ChartAxisMaxValueExtension(dashboardControl), 'ChartAxisMaxValueExtension');
    registerIfNotExists(new ChartConstantLinesExtension(dashboardControl), 'ChartConstantLines');
    registerIfNotExists(new DashboardDescriptionExtension(dashboardControl), 'DashboardDescription');
    registerIfNotExists(new GridHeaderFilterExtension(dashboardControl), 'GridHeaderFilter');
    registerIfNotExists(new ChartScaleBreaksExtension(dashboardControl), 'ScaleBreaks');

    //registerIfNotExists(new DeleteDashboardExtension(dashboardControl, this.dashboardServie), 'DeleteDashboardExtension');

    const parameterDialogExtension = dashboardControl.findExtension('dashboard-parameter-dialog');
    if (parameterDialogExtension) {
      (parameterDialogExtension as any).onShowing = (event: any) => {
        // Set new dimensions if needed
        if (this.localStorageService.get('dashboard-parameter-dialog-width') != null) {
          this.parameterDialogExtensionWidth = this.localStorageService.get('dashboard-parameter-dialog-width');
        }
        if (this.localStorageService.get('dashboard-parameter-dialog-height') != null) {
          this.parameterDialogExtensionHeight = this.localStorageService.get('dashboard-parameter-dialog-height');
        }

        event.component.option({ width: this.parameterDialogExtensionWidth, height: this.parameterDialogExtensionHeight });

        // Handle option changes
        event.component.on('optionChanged', (args: any) => {
          try {
            if (args.name === 'width') {
              this.localStorageService.set('dashboard-parameter-dialog-width', args.component.option('width'));
            }
            if (args.name === 'height') {
              this.localStorageService.set('dashboard-parameter-dialog-height', args.component.option('height'));
            }
          } catch (error) { }
        });
      };
    }

    const viewerApiExtension = dashboardControl.findExtension("viewer-api") as any;
    if (viewerApiExtension != null && viewerApiExtension != undefined) {
      viewerApiExtension.off("dashboardTitleToolbarUpdated", this.onDashboardTitleToolbarUpdated);
    }

    if (viewerApiExtension != null && viewerApiExtension != undefined) {
      viewerApiExtension.on("dashboardTitleToolbarUpdated", this.onDashboardTitleToolbarUpdated);
    }

    (dashboardControl as any).customizeDataItemContainerSections = (dashboardItem, dataItemContainer, sections) => {
      if (dashboardItem.itemType() !== 'CustomItem') return;

      if (dataItemContainer.name === 'columns') {
        sections.push({
          title: 'Custom Column Option',
          items: [
            {
              dataField: 'CustomOptionPerColumn',
              label: { text: 'Custom Column Property' },
              editorType: 'dxTextBox',
              editorOptions: {
                value: dataItemContainer.customOptions?.CustomOptionPerColumn ?? '',
                onValueChanged: (e) => {
                  dataItemContainer.customOptions = dataItemContainer.customOptions || {};
                  dataItemContainer.customOptions.CustomOptionPerColumn = e.value;
                }
              }
            }
          ]
        });
      }
    };

    this.initializeExtension(); // Reapply logic after load

    //apply if extenstion not applied
    registerIfNotExists(new DxDataGridItemExtension(dashboardControl, this.dashboardServie, this.dashboardId, this), 'CustomDataGridExtension');


    // Configure the data grid extension to handle exporting
    dashboardControl.option({
      extensions: {
        dataInspector: {
          onGridInitialized: this.onGridInitialized.bind(this)
        }
      }
    });


  }

  onGridInitialized(e: any) {
    e.component.option({
      export: {
        enabled: true
      },
      onExporting: () => {
        this.excelExportService.exportGrid(e);
      }
    });
  }

  customizeWizard(s, e) {
    if (e.Type === "DashboardDataSourceWizard") {
      e.Wizard.beforeInitialize.add((args) => {
        // Customize the default popup size
        args.state.popupWidth = 1000; // Set the width to 800px
        args.state.popupHeight = 800; // Set the height to 600px
      });
    }
  }

  handleClearCache() {
    if (this.dxdashboardComponent != null && this.dxdashboardComponent != undefined
      && this.dxdashboardComponent.instance != null && this.dxdashboardComponent.instance != undefined
    ) {
      let refresh = this.enableClearCache ?? true;
      if (refresh) {
        this.dxdashboardComponent.instance.reloadData();
      }
      else {
        this.dxdashboardComponent.instance.refresh();
      }
    }
  }

  fullScreenButton = {
    type: 'button',
    icon: 'dx-dashboard-maximize-item',
    hint: 'Full Screen',
    cssClass: 'default-color',
    click: () => {
      this.toggleFullScreen();
    }
  };

  onDashboardTitleToolbarUpdated = (e: any) => {
    // Customize the dashboard title toolbar Add a custom title button
    e.options.actionItems.push({
      type: 'button',
      icon: 'base-circle',
      hint: 'Clear Cache',
      click: () => {
        // Custom title button click handler
        this.handleClearCache();
      }
    }, this.fullScreenButton);
  }

  @ViewChild(DxDashboardControlComponent, { read: ElementRef }) dashboard: ElementRef;
  toggleFullScreen() {
    if (!document.fullscreenElement) {
      // Enter full screen mode
      this.dashboard.nativeElement.requestFullscreen().then(() => {
        // Update the full screen button icon and color
        this.fullScreenButton.icon = 'dx-dashboard-minimize-item';
        this.fullScreenButton.cssClass = 'highlight-color';

      }).catch((err) => {
        console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    } else {
      // Exit full screen mode
      document.exitFullscreen().then(() => {
        // Update the full screen button icon and color
        this.fullScreenButton.icon = 'dx-dashboard-maximize-item';
        this.fullScreenButton.cssClass = 'default-color';
      }).catch((err) => {
        console.error(`Error attempting to exit full-screen mode: ${err.message} (${err.name})`);
      });
    }
    // Refresh the toolbar to apply changes
    // Force UI to update by triggering toolbar update manually
    let viewer = this.dxdashboardComponent.instance.findExtension("viewer-api") as any;
    viewer?.onDashboardTitleToolbarUpdated.fire({
      options: { actionItems: [this.fullScreenButton] }
    });

    // Ensure Angular detects the change
    this.cdr.detectChanges();
  }

  DataGridDefaultOptionsOverwrite() {
    DataGrid.defaultOptions({
      options: {
        showBorders: false,
        showColumnLines: true,
        showRowLines: false,
        rowAlternationEnabled: true,

        columnResizingMode: 'nextColumn',
        columnMinWidth: 50,
        allowColumnReordering: false,
        allowColumnResizing: false,

        sorting: {
          mode: 'multiple'
        },
        selection: {
          mode: 'single'
        },
        scrolling: {
          mode: 'standard',
          useNative: 'auto'
        },
        loadPanel: {
          enabled: true,

          width: 250,
          height: 100,

          text: 'Loading...',

          showIndicator: true,
          indicatorSrc: '/assets/images/rolling.svg'
        },
        filterRow: {
          visible: true,
        },
        headerFilter: {
          visible: true,
        },
      }
    });
  }

  generateUniqueGridId(): string {
    return `DataGrid-${Math.floor(1000 + Math.random() * 9000)}`;
  }

  dashboardEventWithAction(action: string) {
    if (action == "deleteDashboard") {
      this.dxdashboardComponent.instance.refresh();
    }
  }

  private async safeLoadDashboard() {
    this.isLoading = true;
    try {
      if (this.dashboardId) {
        await this.dxdashboardComponent.instance.loadDashboard(this.dashboardId);
        this.loadDashboard(); // Load bookmarks if any
      }
    } catch (error) {
      console.error('Dashboard loading error:', error);
      // Optionally show user feedback
    }
    finally {
      this.isLoading = false;
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy() {
    // Unregister the custom data grid extension if it exists
    if (this.dxdashboardComponent?.instance) {
      // Remove existing extension if it exists
      const existingExt = this.dxdashboardComponent.instance.findExtension('CustomDataGridExtension');
      if (existingExt) {
        this.dxdashboardComponent.instance.unregisterExtension('CustomDataGridExtension');
      }
      this.dxdashboardComponent.instance.unloadDashboard();
    }
    if (this.eventsDashboardSubscription != null && this.eventsDashboardSubscription != undefined) {
      this.eventsDashboardSubscription.unsubscribe();
    }
    // Clean up any other resources or subscriptions
    this.extension = null;

  }

  initializeExtension() {
    try {
      // Ensure the dashboard control is initialized
      if (!this.dxdashboardComponent && !this.dxdashboardComponent.instance) {
        console.error('Dashboard control is not initialized.');
        return;
      }
      let dashboardControl = this.dxdashboardComponent.instance;

      // Check if the dashboardId is set

      // Unregister old extension if it exists
      if (this.extension) {
        dashboardControl.unregisterExtension('CustomDataGridExtension');
      }

      // Remove existing extension if it exists
      const existingExt = dashboardControl.findExtension('CustomDataGridExtension');
      if (existingExt) {
        dashboardControl.unregisterExtension('CustomDataGridExtension');
      }

      // Create new extension with current dashboardId
      this.extension = new DxDataGridItemExtension(
        dashboardControl,
        this.dashboardServie, this.dashboardId, this
      );

      // Register the extension
      dashboardControl.registerExtension(this.extension);
      this.dxdashboardComponent.instance.repaint();
      this.dxdashboardComponent.instance.refresh();
    } catch (error) {
      console.error('Error initializing extension:', error);
    }
  }

  public showDashboardLoader(message?: string): void {
    this.isLoading = true;
  }

  public hideDashboardLoader(): void {
    this.isLoading = false;
  }

}